import React from 'react'

import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

import { BulkSelectionCheckbox } from 'components'
import { TableRow, TableCell } from 'components/Table'
import Actions from './../Actions'

import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

const Row = ({ userCompany, refresh, profiles }) => {
  const classes = useStyles()

  return (
    <TableRow hover>
      <TableCell padding="checkbox" className={classes.checkboxCell}>
        <BulkSelectionCheckbox
          itemId={userCompany?.id}
          label={`Selecionar usuário ${userCompany?.id}`}
        />
      </TableCell>
      <TableCell>{userCompany?.id}</TableCell>
      <TableCell>
        <Typography variant="h6">{userCompany?.user?.name}</Typography>
        <Box pt={1}>
          <Typography variant="body2" color="secondary">
            {userCompany?.user?.email}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        {userCompany?.status === constants.userCompanies.ACTIVE
          ? 'Ativo'
          : 'Inativo'}
      </TableCell>
      <TableCell>{userCompany?.profile?.name || '-'}</TableCell>
      <TableCell>{helpers.formatters.date(userCompany?.createdAt)}</TableCell>
      <TableCell align="right">
        <Actions
          userCompany={userCompany}
          refresh={refresh}
          profiles={profiles}
        />
      </TableCell>
    </TableRow>
  )
}

Row.propTypes = {
  userCompany: PropTypes.object.isRequired,
  refresh: PropTypes.func,
  profiles: PropTypes.array,
}

export default React.memo(Row)
